import { formatDuration } from 'utilities'

export enum ViewerEventEnums {
  INTERACTION_STOPPED = 'interactionStopped',
  PAGE_INTERACTION_STOPPED = 'pageInteractionStopped',
  VIDEO_STOPPED = 'videoStopped',
  PRODUCT_PAGE_OPENED = 'productPageOpened',
  BLOB_TRIGGERED = 'blobTriggered',
  BLOB_ATTACHED = 'blobAttached',
  BLOB_DETACHED = 'blobDetached',
  POSTER_CLICKED = 'posterClicked',
  POSTER_ATTACHED = 'posterAttached',
  VOV_CLICKED = 'vovClicked',
  ADD_TO_CART = 'productAddedToCard',
  PURCHASE = 'productPurchased'
}

export interface ViewerEventInterface {
  userId: string
  eventType: ViewerEventEnums
  duration: number
  projectName: string
  projectId: number
  brandName: string
  brandId: number
  productName: string
  productId: number
}

export class ViewerEvent {
  userId: string
  eventType: ViewerEventEnums
  duration: number
  projectName: string
  projectId: number
  brandName: string
  brandId: number
  productName: string
  productId: number

  constructor (event: ViewerEventInterface) {
    this.userId = event.userId
    this.eventType = event.eventType
    this.duration = event.duration
    this.projectName = event.projectName
    this.projectId = event.projectId
    this.brandName = event.brandName
    this.brandId = event.brandId
    this.productName = event.productName
    this.productId = event.productId
  }

  get durationAsString () {
    return formatDuration(this.duration)
  }
}
